<template>
    <div v-if="registered">
        Logged in.
    </div>
    <div v-else-if="errorMessage">
        <p>{{ errorMessage }}</p>
        <p v-if="showVerificationHint">
            Check the email you used when registering for a verification email.
            If you do not see this email, please check your spam folders!
        </p>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from 'vue';

    let registered = ref(true);
    let errorMessage = ref<string | null>(null);
    let showVerificationHint = ref(false);

    onMounted(() => {
        // Parse URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const errorDescription = urlParams.get('error_description');

        if (errorDescription) {
            errorMessage.value = decodeURIComponent(errorDescription);
            registered.value = false; // Set `registered` to false to show error message

            // Check if the error message contains "verify"
            if (errorMessage.value.toLowerCase().includes('verify')) {
                showVerificationHint.value = true;
            }
        }
    });
</script>

<style>
</style>
